'use strict'

import ApiClient from './ApiClient'

export default class BcIndexRepository {
  /**
   * 会社名索引一覧を取得します。
   * @param {object} params
   * @returns {*}
   */
  getCompanies (params) {
    return ApiClient().get(`/bcindexes-company`, { params })
  }

  /**
   * 会社名-人物索引一覧を取得します。
   * @param {object} params
   * @returns {*}
   */
  getCpeople (params) {
    return ApiClient().get(`/bcindexes-cpeople`, { params })
  }

  /**
   * 人物索引一覧を取得します。
   * @param {object} params
   * @returns {*}
   */
  getPeople (params) {
    return ApiClient().get(`/bcindexes-people`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/BcIndexRepository.js